import { supabase } from "./supabase";
import { fromDbDpr, toDbDprInsert, toDbDprUpdate } from "../lib/mappers";

const DPR_COLUMNS =
  "id, project_id, user_id, dpr_number, report_date, summary_last_24h, summary_next_24h, pdf_url, created_at";

const listDprs = async (projectId) => {
  const { data, error } = await supabase
    .from("dpr_exports")
    .select(DPR_COLUMNS)
    .eq("project_id", projectId)
    .order("dpr_number", { ascending: false });

  if (error) throw error;
  return (data ?? []).map(fromDbDpr);
};

const getDpr = async (dprId) => {
  const { data, error } = await supabase
    .from("dpr_exports")
    .select(DPR_COLUMNS)
    .eq("id", dprId)
    .single();

  if (error) throw error;
  return fromDbDpr(data);
};

const getDprByDate = async (projectId, reportDate) => {
  const { data, error } = await supabase
    .from("dpr_exports")
    .select(DPR_COLUMNS)
    .eq("project_id", projectId)
    .eq("report_date", reportDate)
    .maybeSingle();

  if (error) throw error;
  return data ? fromDbDpr(data) : null;
};

const getNextDprNumber = async (projectId) => {
  const { data, error } = await supabase.rpc("next_dpr_number", {
    p_project_id: projectId,
  });

  if (error) throw error;
  return data;
};

const createDpr = async ({ projectId, userId, reportDate }) => {
  const dprNumber = await getNextDprNumber(projectId);

  const payload = toDbDprInsert({
    projectId,
    userId,
    dprNumber,
    reportDate,
    summaryLast24h: "",
    summaryNext24h: "",
  });

  const { data, error } = await supabase
    .from("dpr_exports")
    .insert(payload)
    .select(DPR_COLUMNS)
    .single();

  if (error) throw error;
  return fromDbDpr(data);
};

const updateDpr = async (dprId, updates) => {
  const payload = toDbDprUpdate(updates);
  const { data, error } = await supabase
    .from("dpr_exports")
    .update(payload)
    .eq("id", dprId)
    .select(DPR_COLUMNS)
    .single();

  if (error) throw error;
  return fromDbDpr(data);
};

const deleteDpr = async (dprId) => {
  const { error } = await supabase
    .from("dpr_exports")
    .delete()
    .eq("id", dprId);
  if (error) throw error;
};

export { listDprs, getDpr, getDprByDate, getNextDprNumber, createDpr, updateDpr, deleteDpr };
